// extracted by mini-css-extract-plugin
export var link = "_uq-0";